import { API } from "@/lib/api";

/**
 * Normalize FastAPI error responses. 422 returns an array of {msg,...} objects
 * which would crash React if rendered directly.
 */
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

async function call(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let payload = null;
  try {
    payload = await res.json();
  } catch {
    // empty body
  }
  if (!res.ok) {
    const msg = formatApiErrorDetail(payload?.detail) || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const authApi = {
  me: () => call("/auth/me"),
  login: (email, password) => call("/auth/login", { method: "POST", body: { email, password } }),
  register: (email, password, name, security_questions, invite_token) =>
    call("/auth/register", {
      method: "POST",
      body: {
        email, password, name,
        ...(security_questions ? { security_questions } : {}),
        ...(invite_token ? { invite_token } : {}),
      },
    }),
  logout: () => call("/auth/logout", { method: "POST" }),
};
